import React from "react";
import { useAuthContext } from "../../../contexts/AuthContext";
import { Link } from "react-router-dom";


export default function Page() {
  const { user } = useAuthContext();


  const adminPannelRoutes = [
    { label: "Courses", route: "course" },
    { label: "Blogs", route: "blog" },
    { label: "Quizes", route: "quiz" },
    { label: "Users", route: "alluser" },
    // { label: "Enrolled Courses", route: "enrolledcourses" },
    // { label: "Student Result", route: "studentsresult" },
   { label: "Quesions", route: "question" },
  ];


  return (
    <>
      <h1 className="mt-24 text-[#fffa8a] text-[48px] text-center italic underline">
        Welcome {user.fullName}
      </h1>
      <div className="container px-5 mt-9 py-18 mx-auto">
        <div className="flex flex-wrap -m-4">
          {adminPannelRoutes.map((item, index) => (
            <div
              key={index}
              className="p-4 contactUSEffect w-[90%] md:w-1/3 mx-auto"
            >
              <Link to={`${item.route}`}>
                <div
                  className="h-full border-2 border-[#fffa8a] border-opacity-60 rounded-lg overflow-hidden"
                >
                  <div className="p-6">
                    <h1 className="title-font text-3xl text-center italic underline font-medium text-[#fffa8a] mb-3">
                      {item.label}
                    </h1>
                      <ul className=" leading-relaxed mb-3 text-[#fffa8a]">
                        <li>Add {item.label}</li>
                        <li>Update {item.label}</li>
                        <li>Delete {item.label}</li>
                      </ul>
               
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
